import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@ontruck/orc';
import ModalHeader from 'modules/journey/map/ModalHeader';
import JourneyMapFilters from 'modules/journey/map/JourneyMapFilters';
import { JourneyMapWrapper } from './journey-map-wrapper';

const JourneyMapModal = ({ isOpened, onClose, className }) => {
  const [vehicleTypeFilterValues, setVehicleTypeFilterValues] = useState([]);

  const toggleVehicleTypeValue = useCallback(
    (vehicleType, value) => {
      value
        ? setVehicleTypeFilterValues([vehicleType, ...vehicleTypeFilterValues])
        : setVehicleTypeFilterValues(
            vehicleTypeFilterValues.filter((item) => item !== vehicleType)
          );
    },
    [vehicleTypeFilterValues]
  );

  if (!isOpened) {
    return null;
  }

  return (
    <Modal
      withPadding={false}
      show={isOpened}
      size="XL"
      onClose={onClose}
      headerComponent={<ModalHeader />}
    >
      <div className={className}>
        <JourneyMapFilters
          onToggleValue={toggleVehicleTypeValue}
          vehicleTypeValues={vehicleTypeFilterValues}
        />

        <JourneyMapWrapper vehicleTypeFilter={vehicleTypeFilterValues} />
      </div>
    </Modal>
  );
};

JourneyMapModal.propTypes = {
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
};

export default JourneyMapModal;
